__turbopack_context__.v({
  "avatar": "AccountMenu-module__dEOyCG__avatar",
  "divider": "AccountMenu-module__dEOyCG__divider",
  "icon": "AccountMenu-module__dEOyCG__icon",
  "identity": "AccountMenu-module__dEOyCG__identity",
  "item": "AccountMenu-module__dEOyCG__item",
  "itemCurrent": "AccountMenu-module__dEOyCG__itemCurrent",
  "itemPanel": "AccountMenu-module__dEOyCG__itemPanel",
  "itemPopover": "AccountMenu-module__dEOyCG__itemPopover",
  "menu": "AccountMenu-module__dEOyCG__menu",
  "name": "AccountMenu-module__dEOyCG__name",
  "nav": "AccountMenu-module__dEOyCG__nav",
  "navBelowProfile": "AccountMenu-module__dEOyCG__navBelowProfile",
  "profile": "AccountMenu-module__dEOyCG__profile",
  "tier": "AccountMenu-module__dEOyCG__tier",
});
